import * as React from 'react';

import './styles.scss';

export const Earth = () => (
  <div className="earth">
    <div className="earth__shadow" />
  </div>
);
